import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc857552"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "v-pre-order" }
const _hoisted_2 = { class: "v-pre-order__intro__txt lo-view__header__txt lo-remove-child-margin lo-g-gutter--half" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "firstname",
  class: "lo-form__label--is-required"
}, [
  /*#__PURE__*/_createTextVNode("Votre prénom "),
  /*#__PURE__*/_createElementVNode("span", null, "| Your firstname")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "lo-form__label--is-required"
}, [
  /*#__PURE__*/_createTextVNode("Votre nom "),
  /*#__PURE__*/_createElementVNode("span", null, "| Your name")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "lo-form__label--is-required"
}, [
  /*#__PURE__*/_createTextVNode("Votre adresse mail "),
  /*#__PURE__*/_createElementVNode("span", null, "| Your mail adress")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country" }, [
  /*#__PURE__*/_createTextVNode("Votre pays "),
  /*#__PURE__*/_createElementVNode("span", null, "|Your country")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, [
  /*#__PURE__*/_createTextVNode("Votre numéro de téléphone "),
  /*#__PURE__*/_createElementVNode("span", null, "| Your phone number")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "message" }, [
  /*#__PURE__*/_createTextVNode("Un message "),
  /*#__PURE__*/_createElementVNode("span", null, "| A message")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "v-form-locked-page__validate lo-form__validate" }, [
  /*#__PURE__*/_createElementVNode("span", null, "envoyer votre demande"),
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "#000000"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" })
  ])
], -1))
const _hoisted_10 = {
  key: 0,
  class: "v-certification__form__waiting-message"
}
const _hoisted_11 = {
  key: 1,
  class: "v-certification__response lo-g-gutter--half"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "v-pre-order__intro lo-view__header",
      style: _normalizeStyle({backgroundImage: `url('${_ctx.preorderData.image?.url}')`,})
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.preorderData.titleName), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.preorderData.description), 1)
      ])
    ], 4),
    (_ctx.status === 'show form' || _ctx.status === 'sending data' )
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["v-certification__form lo-view__form lo-g-gutter--half", {
          'is-sending-data': _ctx.status === 'sending data'
        }])
        }, [
          _createElementVNode("form", {
            class: "lo-form lo-g-row",
            onSubmit: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.formSubmit && _ctx.formSubmit(...args)))
          }, [
            _createElementVNode("div", null, [
              _hoisted_3,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "firstname",
                name: "firstname",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstname) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.firstname]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_4,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "name",
                name: "name",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.name]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                id: "email",
                name: "email",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.email]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "tel",
                id: "country",
                name: "country",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.country) = $event))
              }, null, 512), [
                [_vModelText, _ctx.country]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "tel",
                id: "phone",
                name: "phone",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.phoneNumber) = $event))
              }, null, 512), [
                [_vModelText, _ctx.phoneNumber]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              _withDirectives(_createElementVNode("textarea", {
                id: "message",
                name: "message",
                rows: "10",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.message) = $event))
              }, null, 512), [
                [_vModelText, _ctx.message]
              ])
            ]),
            _hoisted_9
          ], 32),
          (_ctx.status === 'sending data' )
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Envois des informations en cours…"))
            : _createCommentVNode("", true)
        ], 2))
      : (_ctx.status === 'show response')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.responseMassage), 1)
          ]))
        : _createCommentVNode("", true)
  ]))
}